/**
 * Created by MateuszWaligora on 14.07.2017.
 */
import Vue from 'vue';
import {HTTPCODES} from '../../plugins/types';
/**
 * @module Store/orders
 * @description Module for products
 */

/**
 * @constant State of orders store
 * @type {Object}
 * @property {Array} orders - orders fetched from the server
 * @description This constant holds the state of product store
 * */
const state = {
    orders: []
};

/**
 * @constant Getters
 * @type {Object}
 * @property {function} getOrders - returns orders array
 * @description This constant represents the getters for the order store
 * */
const getters = {
    getOrders: state => state.orders
};

/**
 * @constant Mutations
 * @type {Object}
 * @property {function} updateOrders - updates orders array
 * @description This constant represents the mutations for the orders store
 * */
const mutations = {
    updateOrders: (state, orders) => state.orders = orders};

/**
 * @constant Actions
 * @type {Object}
 * @property {function} getOrderListAsync - async action that fetches the orders from the server

 * */
const actions = {
    /**
     * @function getOrderListAsync
     * @description async action that fetches the orders from the server
     * @param {Object} payload - object containing before and after dates
     * @returns {Object} order data or error object
     * */
    async getOrderListAsync ({commit, rootState}, payload) {
        let path = `${rootState.config.orderManagerPort}/order`;
        if(payload) {
            let {before, after} = payload;
            path += '?';
            if(after) {
                path += `after=${payload.after}&`;
            }
            if(before) {
                path += `before=${payload.before}`;
            }
        }
        try {
            let {data} = await Vue.axios.get(path);
            // commit('updateOrders', commitPayload);
            return data || [];
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
            commit('updateOrders', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to get order list'
            });
            throw new Error(err);
        }
    },
    async getOrderByIdAsync ({rootState}, id) {
        let path = `${rootState.config.orderManagerPort}/order/${id}`;
        try {
            let {data} = await Vue.axios.get(path);
            return data;
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                throw new Error(HTTPCODES[err.response.status]);
            }
            throw new Error(err);
        }
    },
    /**
     * @function getOrderListAsync
     * @description async action that fetches the orders from the server
     * @returns {Object} response or error object
     * */
    async deleteOrderFromDatabase ({commit, rootState}, {orderList, orderID}) {
        try {
            let res = await Vue.axios.delete(`${rootState.config.orderManagerPort}/order/${orderID}`);
            commit('updateOrders', orderList);
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `deleted order ${orderID}`
            });
            return res;
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: `to delete order ${orderID}`
                    });
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('updateOrders', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to delete order ${orderID} from database`
            });
            throw new Error(err);
        }
    },
    /**
     * @function repeatPrintAsync
     * @description async action that fetches the orders from the server
     * @param {String} orderID - The order id to print receipt for
     * @returns {Object} response or error object
     * */
    async repeatPrintAsync ({rootState, commit}, {orderID}) {
        try {
            let res = await Vue.axios.get(`${rootState.config.orderManagerPort}/order/${orderID}/print-receipt`);
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `printed receipt for order: ${orderID}`
            });
            return res;
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: `to repeat print for order: ${orderID}`
                    });
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to repeat ${orderID} print`
            });
            throw new Error(err);
        }
    },
    /**
     * @function printOrderAsync
     * @description async action that fetches the orders from the server
     * @param {String} orderID - The order id to print
     * @returns {Object} response or error object
     * */
    async printOrderAsync ({rootState, commit}, {orderID}) {
        try {
            let res = await Vue.axios.get(`${rootState.config.orderManagerPort}/order/${orderID}/repeat`);
            commit('addAlert', {
                title: 'Successfully ',
                type: 'success',
                body: `repeated order ${orderID}`
            });
            return res;
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: `to print order ${orderID}`
                    });
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to print order ${orderID}`
            });
            throw new Error(err);
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
